export function contentVisible() {
    const DOM = {
      options: document.querySelectorAll("[data-actionid=select-content]"),
      contents: document.querySelectorAll("[data-targetid]"),
      accordion: document.querySelectorAll("[data-content=content-accordions]")
    }
    if (DOM.options) {
      
      DOM.options[0].classList.add("active")

      DOM.options.forEach(element => {
        element.addEventListener("click", function() {
          DOM.accordion.forEach((e)=>{
            e.style.display = "none"
          })
          DOM.options.forEach(element => {
            element.classList.remove("active") // Disable
          })

          // Enable
          this.classList.add("active") // enabled

          DOM.contents.forEach(element => {
            if (element.dataset.targetid == this.dataset.contentid) {
              element.classList.remove("hidden")
            } else {
              element.classList.add("hidden")
            }
          })
        })
      })
    }
  }

  if (document.querySelectorAll("[data-actionid=select-content]").length && document.querySelectorAll("[data-targetid]").length) {
    contentVisible();
  }
